import "core-js/stable";
import { LoginRouter } from "@/routers/LoginRouter.tsx";
import { Cvpartner, setCvPartner } from "@/shared/bootstrap/cvpartner.ts";
import "./application_styles.ts";
import "@/cv/bootstrap.ts";
import "@/proposals/bootstrap.ts";
import "@/references/bootstrap.ts";
import "@/dashboard/bootstrap.ts";
import "../shared/ui/navigation.ts";

// Here be dragons
setCvPartner(new Cvpartner(LoginRouter));
